import { useLayout } from '@/contexts/LayoutContext';
import { useTheme } from '@/contexts/ThemeContext';
import TopNavLayout from './TopNavLayout';
import SidebarLayout from './SidebarLayout';
import SidebarLayoutVideogame from './SidebarLayoutVideogame';

/**
 * MainLayout Component
 * Switches between layouts based on BOTH theme and layout mode
 *
 * Layout Selection Logic:
 * 1. Check current theme (videogame, cyberpunk, neobrutal, etc.)
 * 2. Check layout mode (sidebar vs topnav)
 * 3. Return appropriate themed layout component
 *
 * NOTE: VideoGame and Cyberpunk themes ALWAYS use SidebarLayout (topnav disabled by design)
 */
export default function MainLayout() {
  const { layoutMode } = useLayout();
  const { theme } = useTheme();

  // VideoGame and Cyberpunk themes - ALWAYS use SidebarLayoutVideogame
  if (theme === 'videogame' || theme === 'cyberpunk') {
    return <SidebarLayoutVideogame />;
  }

  // All other themes use default layouts
  return layoutMode === 'sidebar' ? <SidebarLayout /> : <TopNavLayout />;
}
